import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BRANDING_SETTINGS_QUERY_KEY = 'accountProfile/branding';

export function useBrandingSettingsQuery(
	params: { impersonationContext?: Api.IImpersonationContext; enabled?: boolean } = {}
) {
	const userSession = useUserSession();
	return useQuery<Api.BrandingSettings | null>({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.BrandingSettings>({
				path: Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'accountProfile/branding',
					impersonationContext: params.impersonationContext,
				}),
				method: 'GET',
				throwOn404: false,
			}),
		queryKey: [BRANDING_SETTINGS_QUERY_KEY, params.impersonationContext],
		enabled: params.enabled ?? true,
	});
}

export function invalidateBrandingSettingsQueries(params: { impersonationContext?: Api.IImpersonationContext } = {}) {
	return reactQueryClient.invalidateQueries({
		queryKey: [BRANDING_SETTINGS_QUERY_KEY, params.impersonationContext],
	});
}
